export const WINNIN_COLOR = '#755CFF'

const COLORS = {
  // Really Base Color
  base_color1: '#000',
  base_color2: '#fff',

  // Main Colors
  primary: '#6324c6',
  primary_light2: '#9B6CE4',
  primary_light1: '#7D41DC',
  primary_dark1: '#431885',
  primary_dark2: '#17092F',

  highlight: '#FFB800',
  highlight_light2: '#ffd466',
  highlight_light1: '#ffc633',
  highlight_dark1: '#b38100',
  highlight_dark2: '#4d3700',

  // Default Background
  background: '#F5F7FB',

  // Gray Scale
  gray: '#A7B0BE',
  gray_light2: '#E2E5E9',
  gray_light1: '#C4CAD4',
  gray_dark1: '#7B899D',
  gray_dark2: '#4C5667',
  gray_dark3: '#7B899D',
  gray_new: '#F1F2FA',

  // Charts
  graph_item_1: '#F7CA00',
  graph_item_2: '#F76D3E',
  graph_item_3: '#3BBA18',
  graph_item_4: '#005DFF',
  graph_item_5: '#EF377A',
  graph_item_6: '#C519F0',
  graph_item_7: '#0EC9F2',
  graph_item_8: '#FD3636',
  graph_item_9: '#A9DC1A',
  graph_item_10: '#FF9B21',
  graph_item_11: '#FA6FA2',
  graph_item_12: '#238508',
  graph_item_13: '#DC5BFC',
  graph_item_14: '#0443B1',
  graph_item_15: '#B5350A',
  graph_item_16: '#00A3FF',
  graph_item_17: '#1ECF8F',
  graph_item_18: '#C4A000',
  graph_item_19: '#D94411',
  graph_item_20: '#780404',
  graph_item_21: '#A2BBCD',
  graph_item_22: '#795E00',
  graph_item_23: '#9570FF',
  graph_item_24: '#0086A4',
  graph_item_25: '#510090',
  graph_item_26: '#9F007C',
  graph_item_27: '#1B654A',
  graph_item_28: '#474747',
  graph_item_29: '#909C00',
  graph_item_30: '#24FF00',

  // Feedback
  success: '#01ADA6',
  warning: '#FFB800',
  danger: '#E92151',

  // Providers
  youtube: '#E33030',
  facebook: '#4267B2',
  instagram: '#fcaf45',
  tiktok: '#000000',
  twitch: '#874FF6',
}

export const GRAPH_COLORS = [
  COLORS.graph_item_1,
  COLORS.graph_item_2,
  COLORS.graph_item_3,
  COLORS.graph_item_4,
  COLORS.graph_item_5,
  COLORS.graph_item_6,
  COLORS.graph_item_7,
  COLORS.graph_item_8,
  COLORS.graph_item_9,
  COLORS.graph_item_10,
  COLORS.graph_item_11,
  COLORS.graph_item_12,
  COLORS.graph_item_13,
  COLORS.graph_item_14,
  COLORS.graph_item_15,
  COLORS.graph_item_16,
  COLORS.graph_item_17,
  COLORS.graph_item_18,
  COLORS.graph_item_19,
  COLORS.graph_item_20,
  COLORS.graph_item_21,
  COLORS.graph_item_22,
  COLORS.graph_item_23,
  COLORS.graph_item_24,
  COLORS.graph_item_25,
  COLORS.graph_item_26,
  COLORS.graph_item_27,
  COLORS.graph_item_28,
  COLORS.graph_item_29,
  COLORS.graph_item_30,
]

export default COLORS
